import gql from 'graphql-tag';

export default gql`
  query {
    application(name: HOTELONLYBOOKING) {
      ... on HotelOnlyBooking {
        translations(language: enUS) {
          searchWidget {
            destinationLabel
            destinationPlaceholder
            checkInLabel
            checkInPlaceholder
            checkOutLabel
            checkOutPlaceholder
            roomNoLabel
            adultsLabel
            childrenLabel
            ageAtCheckInLabel
            searchButtonText
            viewModifyResevation
            roomNumber
            removeRoomButton
            updateSearchButtonText
            cancelSearchButtonText
          }
          searchSummary {
            destinationLabel
            datesLabel
            roomsLabel
            roomsLabelPlural
            roomsLabelSingular
            guestsLabelPlural
            guestsLabelSingular
            adultsLabel
            childrenLabel
            editSearchButtonText
          }
        }
      }
    }
  }
`;
